
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  Experience,
  OrderedExperience,
  SkillFunctionalError,
} from '../models';
import {
    ExperienceFromJSON,
    ExperienceToJSON,
    OrderedExperienceFromJSON,
    OrderedExperienceToJSON,
    SkillFunctionalErrorFromJSON,
    SkillFunctionalErrorToJSON,
} from '../models';

export interface CreateExperienceRequest {
    experience: Experience;
    origin?: CreateExperienceOriginEnum;
}

export interface DeleteGivenExperienceRequest {
    experienceId: string;
    origin?: DeleteGivenExperienceOriginEnum;
}

export interface GetGivenExperienceRequest {
    experienceId: string;
}

export interface OrderExperiencesRequest {
    requestBody: Array<string>;
}

export interface SaveExperiencesRequest {
    experiences: Array<Experience>;
    origin?: SaveExperiencesOriginEnum;
}

export interface UpdateGivenExperienceRequest {
    experienceId: string;
    experience: Experience;
    origin?: UpdateGivenExperienceOriginEnum;
}

/**
 * 
 */
export class ExperienceApi extends runtime.BaseAPI {

    /**
     * Create a new experience for given profile
          */
    async createExperienceRaw(requestParameters: CreateExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrderedExperience>> {
        if (requestParameters['experience'] == null) {
            throw new runtime.RequiredError(
                'experience',
                'Required parameter "experience" was null or undefined when calling createExperience().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['origin'] != null) {
            queryParameters['origin'] = requestParameters['origin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<OrderedExperience>({
            path: `/profile/api/v2/experiences`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExperienceToJSON(requestParameters['experience']),
        }, initOverrides);

        if (response._data) { response._data=OrderedExperienceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a new experience for given profile
          */
    async createExperience(requestParameters: CreateExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrderedExperience> {
        const response = await this.createExperienceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Delete experience from given profile
          */
    async deleteGivenExperienceRaw(requestParameters: DeleteGivenExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['experienceId'] == null) {
            throw new runtime.RequiredError(
                'experienceId',
                'Required parameter "experienceId" was null or undefined when calling deleteGivenExperience().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['origin'] != null) {
            queryParameters['origin'] = requestParameters['origin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/v2/experiences/{experienceId}`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters['experienceId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete experience from given profile
          */
    async deleteGivenExperience(requestParameters: DeleteGivenExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteGivenExperienceRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve experiences from given profile
          */
    async getExperiencesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<Experience>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<Experience>>({
            path: `/profile/api/v2/experiences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ExperienceFromJSON);
        return response;
    }

    /**
     * Retrieve experiences from given profile
          */
    async getExperiences(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<Experience>> {
        const response = await this.getExperiencesRaw(initOverrides);
        return response._data;
    }

    /**
     * Get an experience from given profile
          */
    async getGivenExperienceRaw(requestParameters: GetGivenExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Experience>> {
        if (requestParameters['experienceId'] == null) {
            throw new runtime.RequiredError(
                'experienceId',
                'Required parameter "experienceId" was null or undefined when calling getGivenExperience().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Experience>({
            path: `/profile/api/v2/experiences/{experienceId}`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters['experienceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ExperienceFromJSON(response._data); }
        return response;
    }

    /**
     * Get an experience from given profile
          */
    async getGivenExperience(requestParameters: GetGivenExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Experience> {
        const response = await this.getGivenExperienceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Order experiences from profile
          */
    async orderExperiencesRaw(requestParameters: OrderExperiencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<Experience>>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling orderExperiences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<Array<Experience>>({
            path: `/profile/api/v2/experiences/order`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        response._data=response._data?.map(ExperienceFromJSON);
        return response;
    }

    /**
     * Order experiences from profile
          */
    async orderExperiences(requestParameters: OrderExperiencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<Experience>> {
        const response = await this.orderExperiencesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update experiences for given profile
          */
    async saveExperiencesRaw(requestParameters: SaveExperiencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<Experience>>> {
        if (requestParameters['experiences'] == null) {
            throw new runtime.RequiredError(
                'experiences',
                'Required parameter "experiences" was null or undefined when calling saveExperiences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['origin'] != null) {
            queryParameters['origin'] = requestParameters['origin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<Array<Experience>>({
            path: `/profile/api/v2/experiences`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['experiences']!.map(ExperienceToJSON),
        }, initOverrides);

        response._data=response._data?.map(ExperienceFromJSON);
        return response;
    }

    /**
     * Update experiences for given profile
          */
    async saveExperiences(requestParameters: SaveExperiencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<Experience>> {
        const response = await this.saveExperiencesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update an experience from given profile
          */
    async updateGivenExperienceRaw(requestParameters: UpdateGivenExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Experience>> {
        if (requestParameters['experienceId'] == null) {
            throw new runtime.RequiredError(
                'experienceId',
                'Required parameter "experienceId" was null or undefined when calling updateGivenExperience().'
            );
        }

        if (requestParameters['experience'] == null) {
            throw new runtime.RequiredError(
                'experience',
                'Required parameter "experience" was null or undefined when calling updateGivenExperience().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['origin'] != null) {
            queryParameters['origin'] = requestParameters['origin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<Experience>({
            path: `/profile/api/v2/experiences/{experienceId}`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters['experienceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ExperienceToJSON(requestParameters['experience']),
        }, initOverrides);

        if (response._data) { response._data=ExperienceFromJSON(response._data); }
        return response;
    }

    /**
     * Update an experience from given profile
          */
    async updateGivenExperience(requestParameters: UpdateGivenExperienceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Experience> {
        const response = await this.updateGivenExperienceRaw(requestParameters, initOverrides);
        return response._data;
    }

}

/**
 * @export
 */
export const CreateExperienceOriginEnum = {
    Signup: 'SIGNUP',
    Edition: 'EDITION'
} as const;
export type CreateExperienceOriginEnum = typeof CreateExperienceOriginEnum[keyof typeof CreateExperienceOriginEnum];
/**
 * @export
 */
export const DeleteGivenExperienceOriginEnum = {
    Signup: 'SIGNUP',
    Edition: 'EDITION'
} as const;
export type DeleteGivenExperienceOriginEnum = typeof DeleteGivenExperienceOriginEnum[keyof typeof DeleteGivenExperienceOriginEnum];
/**
 * @export
 */
export const SaveExperiencesOriginEnum = {
    Signup: 'SIGNUP',
    Edition: 'EDITION'
} as const;
export type SaveExperiencesOriginEnum = typeof SaveExperiencesOriginEnum[keyof typeof SaveExperiencesOriginEnum];
/**
 * @export
 */
export const UpdateGivenExperienceOriginEnum = {
    Signup: 'SIGNUP',
    Edition: 'EDITION'
} as const;
export type UpdateGivenExperienceOriginEnum = typeof UpdateGivenExperienceOriginEnum[keyof typeof UpdateGivenExperienceOriginEnum];
